export enum MenuOptions {
    EDIT,
    DELETE,
    RESCHEDULE,
    FORCE_CLOSURE,
    CANCEL_ACTIVITY,
    SEE_INFORM,
    RESEND_INFORM
}